// extracted by mini-css-extract-plugin
export default {"featuredEventCard":"FeaturedEventCard_featuredEventCard__w71Ut","buttonsContainer":"FeaturedEventCard_buttonsContainer__L1IB+"};